/**
 * お知らせ設定ページ用のスクリプト
 */
 if (is_route('information_setting.index')) {
    // コンテンツ読み込み後
    $(document).on('amc:onload', function() {
        information_event_set();
        information_setting_event_set();
    });
}
/**
 * ページ読み込み時のイベント設定
 */
window.information_event_set = function() {

    /*---- 設定表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-setting-modal]', function () {
        _modal.create(this, 'setting-modal', ['id'], false, function(results) {
            information_setting_event_set();
        });
    });

    /*---- 設定の保存確認時 ----*/

    // 設定の保存確認時
    $(document).on('click', '[data-save-confirm-modal]', function () {
        _modal.create(this, 'save-confirm-modal');
    });

    /*---- 設定の保存時 ----*/

    // 設定保存時
    $(document).on('click', '[data-save-modal]', function () {
        _modal.submit(this, 'save-modal', function() {
            _modal.hide($(this).data('save-modal'));
        }, function () {
            _modal.hide('#information-save-modal');
        });
    });
}
/**
 * 設定モーダル表示時のイベント設定
 */
 window.information_setting_event_set = function () {

    function setDisplayOfValueInput(elm) {
        let input = $('input[id=information-setting-modal-' + $(elm).data('target') + ']');
        let inputValue = document.getElementById('information-setting-modal-' + $(elm).data('target'));
        if ($(input).attr('type') != 'hidden') {
            $(input).toggleClass('display-none', ($(elm).val() != '1'));
            $(inputValue).toggleClass('display-none', ($(elm).val() != '1'));
            if ($(input).val() == '') {
                $(input).val($(input).data('default'));
            }
            let suffix = $('#information-setting-modal-' + $(elm).data('target') + '_suffix');
            $(suffix).toggleClass('display-none', ($(elm).val() != '1'));

            // 時間の表示非表示を切り替える
            let labelTime = $('label[for=information-setting-modal-' + $(elm).data('target'));
            $(labelTime).toggleClass('display-none', ($(elm).val() != '1'));
        }

        // 時間を表示する要素の場合は何もしない
        if($(inputValue).is('input.time-minutes-picker')){
            return;
        }

        // 整数以外が入っていたら入力値をクリアする
        if (!isNumber($(inputValue).val())){
            $(inputValue).val('');
        }else{
            var str = $(inputValue).val();
            var inputValue_int = parseInt(str);
            $(inputValue).val(inputValue_int);
        }
    }
    // switch
    $(document).off('change', '.information_item_flag');
    $(document).on('change', '.information_item_flag', function() {
        setDisplayOfValueInput(this);

        // 「アプリでのPush通知」をON/OFFしたときは追加処理を行う
        // 「未測定者通知」タブの項目に対して、display-noneを付けたり、外したりする
        if($(this).is('[data-target="unmeasured_notification"]')){
            const $children = $('#unmeasured_user_notification').children();
            $children.each(function() {
                // 「アプリでのPush通知」は非表示にしない
                if($(this).is('#unmeasured_notification-content')){
                    return;
                }
                $(this).toggleClass('display-none');
            });
        }
    });
    $('.information_item_flag:checked').each(function () {
        setDisplayOfValueInput(this);
    });

    // 整数チェック(符号なし)
    function isNumber(val){
        var regex = new RegExp(/^[0-9]+$/);
        return regex.test(val);
    }
}